const common = require('./config.common');

const config = {
  ...common,
  API_HOST: 'api.beatport.com',
  IDS_HOST: 'account.beatport.com',
  API_CLIENT_ID: 'iFRfav4JQJdG4yQOXmjcLs3SeWm2j3Te0fM3rfIj',
  IS_PROD: true,
  RECURLY_PUBLIC_KEY: 'ewr1-Qmb1cqA14hgGgPNFIMqO7D',
  SENTRY_ENABLED: true,
};

if (typeof window !== 'undefined') {
  window.Config = config;
}

function initializeConfig () {
  return new Promise((resolve, reject) => {
    if (typeof window !== 'undefined' && window.Config.IS_PROD) {
      window.Config = { ...config, ...window.Config };
      fetch('/config.js')
        .then(response => response.text())
        .then(script => {
          const scriptElement = document.createElement('script');
          scriptElement.text = script;
          document.head.appendChild(scriptElement); // Replace window.Config with the one from the script
          window.Config = { ...config, ...window.Config }; // Re-set window.Config with the one from the script
          resolve();
        })
        .catch(error => {
          console.error('Failed to fetch /config.js:', error);
          reject(error); // Reject the promise if the fetch fails
        });
    } else {
      resolve(); // Resolve immediately if `window` is not defined or not in production
    }
  });
}

module.exports = { config, initializeConfig };
